<template>
  <div :class="classObj" class="app-wrapper"
       :style="{ '--current-color': theme }">
    <div v-if="device === 'mobile' && sidebar.opened" class="drawer-bg" @click="handleClickOutside"/>
    <sidebar v-if="!sidebar.hide" class="sidebar-container" />
    <div :class="{ hasTagsView: needTagsView, sidebarHide: sidebar.hide }" class="main-container">
      <div :class="{ 'fixed-header': fixedHeader }">
        <navbar @setLayout="setLayout" />
        <tags-view v-if="needTagsView" />
      </div>
      <app-main />
      <settings ref="settingRef" />
      <customTcccUI/>
      <tcccDialog
        v-model:show="tcccHandler.show"
        :currentRow="tcccHandler.currentRow"
        :type="String(tcccHandler.currentRow.studentType + 1)"
        :acceptSessionId="sessionId"
        :isInnerStudent="tcccHandler.isInnerStudent"
      />
    </div>
  </div>
</template>

<script setup>
import tcccDialog from "@/views/tccc/components/tcccDialog.vue";
import { getInfoByPhoneApi } from "@/api/Tccc/index";
import customTcccUI from "@/views/tccc/components/customTcccUI.vue";
import { useWindowSize } from '@vueuse/core'
import Sidebar from './components/Sidebar/index.vue'
import { AppMain, Navbar, Settings, TagsView } from './components'
import defaultSettings from '@/settings'
import { useTcccStore } from '@/store/modules/tccc'
import useAppStore from '@/store/modules/app'
import useSettingsStore from '@/store/modules/settings'
import { onMounted } from "vue";
import { storeToRefs } from "pinia";

const settingsStore = useSettingsStore()
const theme = computed(() => settingsStore.theme);
const sideTheme = computed(() => settingsStore.sideTheme);
const sidebar = computed(() => useAppStore().sidebar);
const device = computed(() => useAppStore().device);
const needTagsView = computed(() => settingsStore.tagsView);
const fixedHeader = computed(() => settingsStore.fixedHeader);

const classObj = computed(() => ({
  hideSidebar: !sidebar.value.opened,
  openSidebar: sidebar.value.opened,
  withoutAnimation: sidebar.value.withoutAnimation,
  mobile: device.value === 'mobile',
  fullPage: fullPage.value,
}))

const { width, height } = useWindowSize();
const WIDTH = 992; // refer to Bootstrap's responsive design

watchEffect(() => {
  /* if (device.value === 'mobile' && sidebar.value.opened) {
    useAppStore().closeSideBar({ withoutAnimation: false })
  } */
  if (width.value - 1 < WIDTH) {
    useAppStore().toggleDevice('mobile')
    useAppStore().closeSideBar({ withoutAnimation: true })
  } else {
    useAppStore().toggleDevice('desktop')
  }
})

function handleClickOutside() {
  useAppStore().closeSideBar({ withoutAnimation: false })
}

const settingRef = ref(null);
function setLayout() {
  settingRef.value.openSetting();
}
const tcccStore = useTcccStore()
const { sessionId, callInPhone,showTccc,callerLocation } = storeToRefs(tcccStore)
const tcccHandler = reactive({
    currentRow:{},
    show:false,
    isInnerStudent:true,

})
watch(showTccc,async (val)=>{
    if(val){
        try {
            console.log(val,'------------')
            const { data } = await getInfoByPhoneApi(callInPhone.value)
            console.log(val,data)
            if(data){
                tcccHandler.currentRow = {...data};
                tcccHandler.isInnerStudent = true;
            }else{
                tcccHandler.isInnerStudent = false;
                tcccHandler.currentRow = {
                    phone:callInPhone.value,
                    city:callerLocation.value
                }
            }
            tcccHandler.show = true
        } catch (error) {

        }
    }
})
const fullPage = computed(() => useAppStore().fullPage);
</script>

<style lang="scss" scoped>
@import "@/assets/styles/mixin.scss";
@import "@/assets/styles/variables.module.scss";

.app-wrapper {
  --el-menu-base-level-padding:10px;
  --el-menu-level-padding:10px;
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  overflow-y: auto;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$base-sidebar-width});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.sidebarHide .fixed-header {
  width: 100%;
}

.mobile .fixed-header {
  width: 100%;
}


// 页面全屏支持
.app-wrapper.app-wrapper.fullPage {
  .sidebar-container {
    display: none;
  }
  .fixed-header {
    display: none;
  }
  .app-main {
    padding: 0;
  }

  .main-container {
    margin-left: 0 !important;
  }
}

</style>
